<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
    ></page-template>

  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';


  import userPower from '@/mixin/userPower'

  export default {
    mixins: [userPower],
    components: {
      pageTemplate
    },
    data() {
      return {
        listShow: false,
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {label: " ", prop: "goodsName", type: "input", span: 12, isFuzzy: true, placeholder: "请输入条码/品名/自编码"},
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              // defaultValue: '10',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              span: 6,
              data: [],
              isHasAll: true,
              url: api.store.store,
              change: this.storeChange,
            },
            {
              label: '供应商',
              type: 'select',
              prop: 'supplierId',
              data: [],
              span: 6,
              // url: api.archives.supplier,
            },
            {
              label: '品牌',
              type: 'select',
              prop: 'goodsBrandId',
              data: [],
              span: 6,
              // url: api.archives.brand,
            },
            {
              label: "类别",
              type: 'cascaderMultiple',
              prop: 'goodsCategoryIds',
              data: [],
              span: 6,
              valueKey: 'value',
              change: this.typeChange,
              url: api.archives.getCategoryTree,
            },
            {label: "业务单号", prop: "orderNo", type: "input", span: 12, placeholder: "请输入单号"},
          ]
        },
        // 表格信息配置
        tableOptions: {
          tableName: 'clearTable',
          showSelect: true,
          indexShow: true,//是否显示索引
          param: {
            stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
          },
          columns: [
            {label: '业务单号', prop: 'orderNo', width: '210', align: 'center'},
            {label: '门店名称', prop: 'storeName', width: '120', align: 'center'},
            {label: '条码', prop: 'barCode', width: '120', align: 'center'},
            {label: '品名', prop: 'goodsName', width: '120', align: 'center'},
            {label: '自编码', prop: 'artNo', width: '120', align: 'center'},
            {label: '单位', prop: 'unitName', width: '70', align: 'center'},
            {label: '规格', prop: 'specs', width: '70', align: 'center'},
            {label: '原成本价', prop: 'purchasePrice', width: '120', align: 'center'},
            {label: '新成本价', prop: 'paPurchasePrice', width: '120', align: 'center'},
            {label: '调价日期', prop: 'lastModifyDttm', width: '150', align: 'center'},
            // {label: '数量', prop: 'goodsNum', width: '100', align: 'center'},
            // {label: '差异金额', prop: 'differencePrice', width: '120', align: 'center'},
          ],
          url: api.warehouse.purchaseAdjustmentQuery
        }
      };
    },
    created() {
      this.setStore(this.searchOptions.complex)
    },
    methods: {
      storeChange(row) {
        row.supplierId = '';
        row.goodsBrandId = '';
        let supplierId = [];
        let goodsBrandId = [];
        supplierId = this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0];
        goodsBrandId = this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0];
        //通过门店id获取供应商以及仓库
        this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: row.storeId}).then(data => {
          if (data.code === 200) {
            supplierId.data = data.data;
          }
        });
        // 品牌数据
        this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: row.storeId}).then(data => {
          if (data.code === 200) {
            goodsBrandId.data = data.data;
          }
        });
      }
    }
  };
</script>
<style scoped>
  .page-template {
    padding-top: 0;
  }
</style>





// WEBPACK FOOTER //
// src/page/warehouse/purchase/Query.vue